import { ShareButton, type ShareButtonProps } from '../ShareButton/ShareButton';

interface ShareButtonContainerProps extends Omit<ShareButtonProps, 'onClick'> {
  url: string;
  title: string;
  text: string;
  onShareSuccess?: () => void;
  onShareError?: () => void;
  /**
   * Fired synchronously when the user clicks the share button, before any
   * clipboard or `navigator.share` work. Use this for analytics so tracking
   * is queued before the share UI may steal focus.
   */
  onShareClick?: () => void;
}

export function ShareButtonContainer(props: ShareButtonContainerProps) {
  const { url, title, text, onShareSuccess, onShareError, onShareClick } =
    props;
  return (
    <ShareButton
      {...props}
      onClick={async () => {
        onShareClick?.();

        const data = {
          title,
          text,
          url: url,
        };

        try {
          await navigator.clipboard.writeText(props.url);
          onShareSuccess?.(); // Toast for "copied to clipboard"
        } catch {
          onShareError?.(); // Toast for "failed to copy to clipboard"
        }

        try {
          navigator.canShare(data) && (await navigator.share(data));
        } catch {}
      }}
    />
  );
}
